export default {
    inserted( el, binding, vnode ) { 
        el.dataset.oldStyle = el.getAttribute( 'style' ) || '';
        el.style.display = 'none';
        update( el, binding, vnode )

    }, 
    update: update
};

function update ( el, binding, vnode) {
    const { value = [], modifiers = {} } = binding;
    const elKey = Object.keys( modifiers )[ 0 ];
    const showEl = value.find( item => item.code === elKey );

    showEl ? el.setAttribute( 'style', el.dataset.oldStyle ) : el.style.display = 'none'
   
}


// WEBPACK FOOTER //
// ./src/directive/button.js